import React from 'react';
import Script from 'next/script';

const GoogleTagManager = () => {
  return (
    <React.Fragment>
      <Script id="google-tag-manager" strategy="lazyOnload">
        {process.env.TAG_MANAGER_URL_SUFFIX
          ? `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        '${process.env.TAG_MANAGER_URL}/${process.env.TAG_MANAGER_URL_SUFFIX}.js?aw='+i.replace(/^GTM-/, '')+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${process.env.TAG_MANAGER_ID}');`
          : `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl+'&gtm_auth=${process.env.TAG_MANAGER_AUTH}';
        f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${process.env.TAG_MANAGER_ID}');`}
      </Script>
    </React.Fragment>
  );
};

export default GoogleTagManager;
